import { useSelector } from 'react-redux'
import { Grid } from '@mui/material'

import GridCard from '../components/GridCard'
import GeneralDocs from '../components/GeneralDocs'
import GeneralInfo from '../components/GeneralInfo'
import SelectionBar from '../components/selection/SelectionBar'
import { config } from '../settings/configs'
import { useGetCalendariStatsQuery } from '../hooks/api-slice'

const DashboardOmologatore = () => {
  const selectedCampionato = useSelector(
    state => state.selection.selectedCampionato,
  )

  document.title = `${config?.name} - Home`

  const { data: partiteStats } = useGetCalendariStatsQuery(selectedCampionato, {
    skip: !selectedCampionato,
  })

  return (
    <Grid
      container
      paddingX={2}
      marginY={2}
      rowSpacing={3}
      columnSpacing={2}
      alignItems='stretch'
      sx={{ width: '100%' }}
    >
      <GeneralInfo />
      <Grid container alignItems='center' sx={{ width: '100%' }}>
        <SelectionBar yCampionato />
      </Grid>
      <p style={{ margin: 20, width: '100%' }}>
        Benvenuto nel profilo di omologazione di {config?.name}.
        <br />
        {config?.features?.calendari && (
          <>
            Dalla pagina <b>Calendari</b> puoi omologare e correggere i
            risultati delle gare.
            <br />
          </>
        )}
        Buon lavoro!
      </p>
      {config?.features?.calendari && (
        <GridCard
          title='Calendari'
          subtitle1={`${partiteStats?.withResult || 0} ${
            partiteStats?.withResult === 1
              ? 'risultato inserito'
              : 'risultati inseriti'
          }`}
          subtitle2={`${partiteStats?.withHomologation || 0} ${
            partiteStats?.withHomologation === 1
              ? 'risultato omologato'
              : 'risultati omologati'
          }`}
          linkTo='/calendari'
          isError={partiteStats?.withHomologation < partiteStats?.withResult}
        />
      )}
      <GeneralDocs />
    </Grid>
  )
}

export default DashboardOmologatore
